var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 26,
    viewBox: "0 0 30 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99935 11.6667H5.13268C4.38595 11.6667 4.01258 11.6667 3.72736 11.812C3.47648 11.9398 3.2725 12.1438 3.14467 12.3947C2.99935 12.6799 2.99935 13.0533 2.99935 13.8V25M20.9993 11.6667H24.866C25.6128 11.6667 25.9861 11.6667 26.2713 11.812C26.5222 11.9398 26.7262 12.1438 26.854 12.3947C26.9993 12.6799 26.9993 13.0533 26.9993 13.8V25M20.9993 25V5.26667C20.9993 3.77319 20.9993 3.02646 20.7087 2.45603C20.453 1.95426 20.0451 1.54631 19.5433 1.29065C18.9729 1 18.2262 1 16.7327 1H13.266C11.7725 1 11.0258 1 10.4554 1.29065C9.95361 1.54631 9.54566 1.95426 9.29 2.45603C8.99935 3.02646 8.99935 3.77319 8.99935 5.26667V25M28.3327 25H1.66602M13.666 6.33333H16.3327M13.666 11.6667H16.3327M13.666 17H16.3327",
    stroke: "#475467",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings2);
export default __webpack_public_path__ + "static/media/buildings2.373548398db37a9889286c03a8ef6aec.svg";
export { ForwardRef as ReactComponent };